import register from '@kpsys/angularjs-register';
import {SseService} from './sse.service';
import {NetworkInfoService} from './network-info.service';

export default register('portaro.realtime')
    .service(NetworkInfoService.serviceName, NetworkInfoService)
    .service(SseService.serviceName, SseService)
    .name();